export default {"src":"/_next/static/media/arrowdown-gray.14d1d6f4.svg","height":8,"width":14,"blurWidth":0,"blurHeight":0};